import { render, staticRenderFns } from "./systemless.vue?vue&type=template&id=3b57c1a2&scoped=true&"
import script from "./systemless.vue?vue&type=script&lang=ts&"
export * from "./systemless.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b57c1a2",
  null
  
)

export default component.exports